<app-header></app-header>
<div class="vt-body">
  <app-animated-bg class="no-print"></app-animated-bg>

  <div class="vt-card">
    <div *ngIf="!transaction && initialized" class="location-waiting">
      Please select a location.
    </div>

    <div *ngIf="transaction">
    <div class="selected-option">
      {{transaction.locationName}}
    </div>

    <ng-container *ngIf="!transaction.ledger && transaction.ledgers">
      <div class="options-header">Transaction Type</div>
      <ng-container *ngFor="let ledger of transaction.ledgers">
        <div class="button-full" (click)="setTransactionLedger(ledger)">{{ledger.name}}</div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="transaction.ledger">
      <div class="selected-option">
        {{transaction.ledger.name}}
      </div>

      <ng-container *ngIf="!transaction.action">
        <div class="options-header">What do you want to do?</div>
      <ng-container *ngFor="let action of transaction.ledger.actions">
        <div *ngIf="action.vtCompatible !== false" class="button-full" (click)="setTransactionAction(action)">{{action.name}}</div>
      </ng-container>
        
      </ng-container>

      <ng-container *ngIf="transaction.action">
        <div class="selected-option">
          {{transaction.action.name}}
        </div>


        <!-- Transaction Type and Action are selected. Determine the necessary inputs -->
        <div *ngIf="transaction.ledger.subtypes && transaction.ledger.subtypes.length > 0 && transaction.action.key != 'check' && transaction.action.key != 'history'" class="field">
          <label>Subtype</label>
          <div>
            <select [(ngModel)]="transaction.subtype">
              <option [value]="undefined">-</option>
              <option *ngFor="let subtype of transaction.ledger.subtypes" [value]="subtype.key">{{subtype.name}}</option>
            </select>
          </div>
        </div>

        <div *ngIf="transaction.action.key != 'check' && transaction.action.key != 'history'" class="field">
          <label>Amount</label>
          <div>
            {{transaction.ledger.amount.prefix}}<input class="amount" type="number" [(ngModel)]="transaction.amount" (ngModelChange)="amountChanged($event)" />{{transaction.ledger.amount.suffix}}
          </div>
        </div>

        <!-- Key entry for non-card ledgers (gift cards etc.). A credit ledger without a
             tokenizer URL gets no raw Card Number box: a PAN typed here would be
             stored as the account key, so it is a configuration error instead. -->
        <div *ngIf="transaction.ledger.account.selector == 'key' && !transaction.ledger.account.tokenizerUrl && transaction.ledger.type != 'credit'" class="field">
          <ng-container *ngIf="transaction.ledger.account.searchable">
            <div>
              <label>Account</label>
              <div *ngFor="let account of transaction.accounts" class="account-option" [class.selected]="account === transaction.account" (click)="selectAccount(account)">{{account.name}}</div>
            </div>
          </ng-container>
          <ng-container *ngIf="!transaction.ledger.account.searchable">
            <label>Card Number</label>
            <div>
              <input class="key" type="text" [(ngModel)]="transaction.key" (ngModelChange)="keyChanged($event)" (keyup.enter)="keyEntered()" />
            </div>
          </ng-container>
        </div>

        <div *ngIf="transaction.ledger.type == 'credit' && !transaction.ledger.account.tokenizerUrl" class="field warning">
          This credit card ledger has no tokenizer configured. Card numbers cannot be entered here.
        </div>

        <div *ngIf="transaction.ledger.account.tokenizerUrl" class="field">
          <iframe id="rfoos" title="credit-card-payment" [src]="transaction.oosUrl" frameborder="0" [height]="transaction.ledger.tokenizerHeight+'px'" width="100%"></iframe>
        </div>

        <div *ngIf="transaction.action.key != 'history'" class="field">
          <label>Note</label>
          <div>
            <textarea [(ngModel)]="transaction.note" class="note"></textarea>
          </div>
        </div>

        <!-- <div *ngIf="transaction.action.customerIdAllowed" class="field">
          CUSTOMER SELECT
        </div> -->

        <ng-container>
          <div *ngIf="transaction.action.key == 'check'" class="button-full green" (click)="transact()">Check Balance</div>
          <div *ngIf="transaction.action.key == 'history'" class="button-full green" (click)="getHistory()">View History</div>
          <div *ngIf="transaction.action.key != 'check' && transaction.action.key != 'history'" class="button-full green" [class.disabled]="!transaction.valid || transaction.processing" (click)="transact()">{{transaction.ledger.amount.prefix}}{{transaction.amountDisplay}}{{transaction.ledger.amount.suffix}}</div>
        </ng-container>

        <div *ngIf="transaction.successCount">Success Count: {{transaction.successCount | rf:'number'}}</div>

        <div class="transaction-responses">
          <div class="transaction-response" *ngFor="let response of responses">
            
            <ng-container *ngIf="transaction.action.key == 'history'">
              <div>Transaction ID: <span>{{response._id}}</span></div>
              <div>Time: <span>{{response.time | rf:'dateTime'}}</span></div>
              <div *ngIf="response.locationName">Location: <span>{{response.locationName}}</span></div>
              <div *ngIf="response.action">Action: <span>{{response.action}}</span></div>
              <div *ngIf="response.amount">Amount: <span>{{response.amount}}</span></div>
              <div *ngIf="response.endBalance">Balance: <span>{{response.endBalance}}</span></div>
              <div *ngIf="response.lastFour">Last 4: <span>xxxx{{response.lastFour}}</span></div>
              <div *ngIf="response.msg">MSG: <span>{{response.msg}}</span></div>
            </ng-container>

            <ng-container *ngIf="transaction.action.key != 'history'">
              <div>Transaction ID: <span>{{response.transactionId}}</span></div>
              <div>Time: <span>{{response.time | rf:'dateTime'}}</span></div>
              <div *ngIf="response.amount">Amount: <span>{{response.amount}}</span></div>
              <div *ngIf="response.balance">Balance: <span>{{response.balance}}</span></div>
              <div *ngIf="response.lastFour">Last 4: <span>xxxx{{response.lastFour}}</span></div>
              <div *ngIf="response.msg">MSG: <span>{{response.msg}}</span></div>
            </ng-container>

          </div>
          <!-- <div class="transaction-response" *ngFor="let response of responses">{{response | json}}</div> -->
        </div>

        <div *ngIf="transaction.error" class="error">
          {{transaction.error.msg}}
        </div>





      </ng-container>

    </ng-container>








  </div>
  <app-support *ngIf="supportActive"></app-support>
  <app-settings *ngIf="settingsActive"></app-settings>
</div>

<router-outlet></router-outlet>
